@let creditEntity = credit();
@if (
  creditEntity && (credit()?.operationNumber || credit()?.operation?.number)
) {
  <div #titleElement mat-dialog-title class="pe-2">
    <button type="button" mat-icon-button mat-dialog-close>
      <ft-icon name="arrow-left" class="ft-icon--2" />
    </button>
    <div class="flex-grow-1" i18n>Credit</div>
    <button
      type="button"
      mat-icon-button
      i18n-title
      title="More options"
      [matMenuTriggerFor]="optionsMenu"
      (click)="$event.stopPropagation()">
      <ft-icon name="ellipsis-vertical" class="ft-icon--2" />
    </button>
    <mat-menu #optionsMenu="matMenu">
      @for (
        group of creditService.getContextActions(creditEntity, 'detail');
        track group.id
      ) {
        @if ($index > 0) {
          <hr class="my-2" />
        }
        @for (action of group.children; track action.id) {
          <button type="button" mat-menu-item (click)="action.click()">
            {{ action.label }}
          </button>
        }
      }
    </mat-menu>
  </div>
  <div #contentElement mat-dialog-content class="p-0">
    <mat-tab-group
      #tabsElement
      class="ft-mat-tabs ft-mat-tabs--detail"
      [selectedIndex]="selectedTab()"
      mat-stretch-tabs="false"
      mat-align-tabs="center"
      style="height: 100%">
      <mat-tab label="General">
        <div class="px-4 px-md-5 py-4">
          @if (!isBeneficiary()) {
            <div class="ft-card ft-card--primary flex-grow-1">
              <div class="ft-card__body ft-card__body--primary">
                <div class="d-flex flex-column flex-md-row gap-3">
                  <div class="ft-data-field">
                    <div class="ft-data-field__label" i18n>
                      Interest earned to date
                    </div>
                    <div
                      class="ft-data-field__value d-flex align-items-center justify-content-center gap-1"
                      style="font-size: var(--ft-display-font-size-lg)">
                      <div>{{ credit()?.interestEarnedToDate | number }}</div>
                      <div class="ft-suffix ft-suffix--sm">
                        {{ currencyId() }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ft-card__body ft-card__body--secondary">
                <div class="d-flex gap-3">
                  <div class="ft-data-field flex-grow-1">
                    <div class="ft-data-field__label" i18n>Amount</div>
                    <div class="ft-data-field__value">
                      {{ credit()?.amount | number }}
                    </div>
                  </div>
                  <div class="ft-separator"></div>
                  <div class="ft-data-field flex-grow-1">
                    <div class="ft-data-field__label" i18n>Term</div>
                    <div class="ft-data-field__value">
                      {{ credit()?.term }}
                      {{ credit()?.frequency?.description }}
                    </div>
                  </div>
                  <div class="ft-separator"></div>
                  <div class="ft-data-field flex-grow-1">
                    <div class="ft-data-field__label" i18n>Rate</div>
                    <div class="ft-data-field__value">
                      {{ credit()?.rate }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="ft-card ft-card--primary flex-grow-1">
              <div class="ft-card__body ft-card__body--primary">
                <div class="d-flex flex-column flex-md-row gap-3">
                  <div class="ft-data-field">
                    <div class="ft-data-field__label" i18n>
                      Total Overdue Installments Amount
                    </div>
                    <div
                      class="ft-data-field__value d-flex align-items-center justify-content-center gap-1"
                      style="font-size: var(--ft-display-font-size-lg)">
                      <div>
                        {{
                          credit()?.operation?.installment
                            ?.totalOverdueInstallmentsAmount | number
                        }}
                      </div>
                      <div class="ft-suffix ft-suffix--sm">
                        {{ currencyId() }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ft-card__body ft-card__body--secondary">
                <div class="d-flex gap-3">
                  <div class="ft-data-field flex-grow-1">
                    <div class="ft-data-field__label" i18n>Amount</div>
                    <div class="ft-data-field__value">
                      {{ credit()?.operation?.amount | number }}
                    </div>
                  </div>
                  <div class="ft-separator"></div>
                  <div class="ft-data-field flex-grow-1">
                    <div class="ft-data-field__label" i18n>Term</div>
                    <div class="ft-data-field__value">
                      {{ credit()?.operation?.term }}
                      {{ credit()?.operation?.frequency?.description }}
                    </div>
                  </div>
                  <div class="ft-separator"></div>
                  <div class="ft-data-field flex-grow-1">
                    <div class="ft-data-field__label" i18n>Rate</div>
                    <div class="ft-data-field__value">
                      {{ credit()?.operation?.rate }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <h3 class="d-flex align-items-center gap-2">
            <div i18n>General information</div>
          </h3>
          <div class="ft-table__wrapper">
            @if (!isBeneficiary()) {
              <table class="ft-table">
                <tbody>
                  <tr isGranted="dwl-group">
                    <th class="text-start" i18n>Group</th>
                    <td>{{ credit()?.group?.description || 'N/A' }}</td>
                  </tr>
                  <tr>
                    <th class="text-start" i18n>Amount recovered to date</th>
                    <td>{{ credit()?.amountRecoveredToDate | number }}</td>
                  </tr>
                  <tr>
                    <th class="text-start" i18n>Start date</th>
                    <td>{{ credit()?.effectiveDate | date: 'dd/MM/yyyy' }}</td>
                  </tr>
                  <tr>
                    <th class="text-start" i18n>Expiration date</th>
                    <td>{{ credit()?.expirationDate | date: 'dd/MM/yyyy' }}</td>
                  </tr>
                </tbody>
              </table>
            } @else {
              <table class="ft-table">
                <tbody>
                  <tr>
                    <th class="text-start" i18n>Start date</th>
                    <td>
                      {{ credit()?.operation?.startDate | date: 'dd/MM/yyyy' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-start" i18n>Expiration date</th>
                    <td>
                      {{ credit()?.operation?.endDate | date: 'dd/MM/yyyy' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            }
          </div>
          @if (!isBeneficiary()) {
            <h3 class="d-flex align-items-center gap-2">
              <div i18n>Beneficiary data</div>
            </h3>
            <div class="ft-table__wrapper">
              <table class="ft-table">
                <tbody>
                  <tr>
                    <th class="text-start" i18n>Alias</th>
                    <td>{{ credit()?.beneficiary?.alias }}</td>
                  </tr>
                  <tr>
                    <th class="text-start" i18n>Email</th>
                    <td>{{ credit()?.beneficiary?.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
          <h3 class="mt-4" i18n>Notifications</h3>
          @if (!isBeneficiary()) {
            <div class="d-flex flex-column mb-3 gap-3">
              <mat-checkbox
                [checked]="credit()?.notifyPayment"
                [disabled]="true">
                <div i18n>Payment reminder</div>
                <small class="text-muted" i18n>
                  If you activate this option, we will send reminders to your
                  beneficiary before each installment is due.
                </small>
              </mat-checkbox>
              <mat-checkbox
                [checked]="credit()?.notifyOverduePayment"
                [disabled]="true">
                <div i18n>Reminder of overdue payments</div>
                <small class="text-muted" i18n>
                  If you activate this option, we will send reminders to your
                  beneficiary about the pending installments.
                </small>
              </mat-checkbox>
              <mat-checkbox
                [checked]="credit()?.notifySendingReceipts"
                [disabled]="true">
                <div i18n>Sending receipts</div>
                <small class="text-muted" i18n>
                  If you activate this option, we will send a notification to
                  your beneficiary each time you record a payment on the loan.
                </small>
              </mat-checkbox>
            </div>
          } @else {
            <div class="d-flex flex-column mb-3 gap-3">
              <mat-checkbox
                [checked]="
                  credit()?.operation?.beneficiary
                    ?.sendsUpcomingPaymentNotification
                "
                [disabled]="true">
                <div i18n>Payment reminder</div>
                <small class="text-muted" i18n>
                  If this option is activated, you will receive reminders before
                  each installment is due.
                </small>
              </mat-checkbox>

              <mat-checkbox
                [checked]="
                  credit()?.operation?.beneficiary
                    ?.sendsOverduePaymentNotification
                "
                [disabled]="true">
                <div i18n>Overdue payment reminder</div>
                <small class="text-muted" i18n>
                  If this option is activated, you will receive reminders about
                  any overdue installments.
                </small>
              </mat-checkbox>

              <mat-checkbox
                [checked]="
                  credit()?.operation?.beneficiary?.sendsReceiptNotification
                "
                [disabled]="true">
                <div i18n>Payment receipts</div>
                <small class="text-muted" i18n>
                  If this option is activated, you will receive a notification
                  each time a payment is recorded for this loan.
                </small>
              </mat-checkbox>
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab i18n-label label="Installments">
        <div class="px-4 px-md-5 py-4" style="width: fit-content">
          <div class="ft-card" style="width: fit-content">
            <table class="ft-table">
              <thead>
                <tr>
                  <th></th>
                  <th i18n>Date</th>
                  <th class="text-end text-nowrap" i18n>Capital balance</th>
                  <th class="text-end" i18n>Capital</th>
                  <th class="text-end" i18n>Interest</th>
                  <th class="text-end" i18n>Installment</th>
                  <th class="text-end" i18n>Balance</th>
                  <th i18n>Status</th>
                </tr>
              </thead>
              <tbody>
                @for (record of paymentTable(); track record.hash) {
                  <tr>
                    <th class="text-start text-nowrap">{{ record.number }}</th>
                    <th class="text-nowrap">
                      {{ record.dueDate | date: 'dd/MM/yyyy' }}
                    </th>
                    <td class="text-end">{{ record.prinAmtBal | number }}</td>
                    <td class="text-end">{{ record.prinAmt | number }}</td>
                    <td class="text-end">{{ record.interest | number }}</td>
                    <td class="text-end">{{ record.quotaAmount | number }}</td>
                    <td class="text-end">
                      {{ record.amountOverdueToDate | number }}
                    </td>
                    <td class="text-nowrap">{{ record.state }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          @if (!pagePaymentTableCompleted()) {
            <div
              class="ft-table__loader"
              (ftObserveIntersecting)="nextPage($event)">
              <ft-progress class="ft-progress--2"></ft-progress>
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab i18n-label label="Payments">
        <div class="px-4 px-md-5 py-4" style="min-width: fit-content">
          @if (!paymentsLoaded()) {
            <div
              class="d-flex align-items-center justify-content-center p-5 gap-3">
              <ft-progress class="ft-progress--2"></ft-progress>
              <div i18n>Loading payments...</div>
            </div>
          } @else if (payments().length > 0) {
            <div class="ft-card" style="width: fit-content">
              <table class="ft-table">
                <thead>
                  <tr>
                    <th class="text-nowrap" i18n>Receipt number</th>
                    <th class="text-nowrap" i18n>Payment date</th>
                    <th class="text-nowrap" i18n>Description</th>
                    <th class="text-center text-nowrap" i18n>
                      Applied installments
                    </th>
                    <th class="text-end" i18n>Amount</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (payment of payments(); track payment.ticketNumber) {
                    <tr>
                      <th class="text-start text-nowrap">
                        {{ payment.ticketNumber }}
                      </th>
                      <td class="text-start text-nowrap">
                        {{ payment.paymentDate | date: 'dd/MM/yyyy' }}
                      </td>
                      <td class="text-start text-nowrap">
                        {{ payment.ticketType }}
                      </td>
                      <td class="text-center">{{ payment.appliedQuotas }}</td>
                      <td class="text-end">
                        {{ payment.ticketAmount | number }}
                      </td>
                      <td class="ft-actions px-1">
                        @let contextMenu = getPaymentContextActions(payment);
                        @if (contextMenu.length > 0) {
                          <button
                            type="button"
                            mat-icon-button
                            i18n-title
                            title="More options"
                            [matMenuTriggerFor]="paymentMenu">
                            <ft-icon
                              name="ellipsis-vertical"
                              class="ft-icon--2" />
                          </button>
                          <mat-menu #paymentMenu="matMenu">
                            @for (
                              group of getPaymentContextActions(payment);
                              track group.id
                            ) {
                              @if ($index > 0) {
                                <hr class="my-2" />
                              }
                              @for (action of group.children; track action.id) {
                                <button
                                  type="button"
                                  mat-menu-item
                                  (click)="action.click()">
                                  {{ action.label }}
                                </button>
                              }
                            }
                          </mat-menu>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div style="opacity: 0; position: absolute; pointer-events: none">
              <div
                #paymentElement
                class="ft-payment ft-content--finished ft-sharing-container">
                <div class="ft-card mb-3">
                  <div class="ft-card__body text-center">
                    <div>
                      <div class="ft-icon ft-icon--lead ft-icon--3">
                        <svg
                          viewBox="0 0 24 24"
                          style="
                            width: 1em;
                            height: 1em;
                            vertical-align: middle;
                            fill: currentColor;
                            display: inline-block;
                            font-size: 2rem;
                          ">
                          <path
                            stroke="currentColor"
                            stroke-width="2"
                            d="M19.5 6.5l-10 10-5-5"
                            fill="none"></path>
                        </svg>
                      </div>
                    </div>
                    <div class="ft-data-field">
                      <div
                        class="ft-data-field__value"
                        style="
                          font-size: var(--ft-display-font-size-lg);
                          margin-top: 1rem;
                        ">
                        {{ selectedPayment()?.ticketAmount }}
                        <span class="ft-suffix ft-suffix--sm">
                          {{ currencyId() }}
                        </span>
                      </div>
                      <div class="ft-data-field__label" i18n>Amount paid</div>
                    </div>
                    <div class="mt-4 fs-6 text-success" i18n>
                      Payment registered successfully
                    </div>
                    <div class="ft-info">
                      <hr class="my-3" />
                      <div class="ft-grid ft-grid--c-2">
                        <div class="ft-data-field">
                          <div class="ft-data-field__value">
                            {{ selectedPayment()?.ticketNumber }}
                          </div>
                          <div class="ft-data-field__label" i18n>Receipt #</div>
                        </div>
                        <div class="ft-data-field">
                          <div class="ft-data-field__value">
                            {{
                              selectedPayment()?.paymentDate
                                | date: 'dd/MM/yyyy'
                            }}
                          </div>
                          <div class="ft-data-field__label" i18n>Date</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ft-payment__brand">
                    <img src="images/logo-meprestas.svg" alt="Logo MePrestas" />
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="text-center p-5" i18n>
              You have no recorded payments
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
}
